/* Turkish (primary) */
const tr = {
  /* ---------- Navigation ---------- */
  "nav.home":      "Ana Sayfa",
  "nav.plans":     "Planlar",
  "nav.devices":   "Cihazlar",
  "nav.app":       "Uygulama",
  "nav.dashboard": "Panelim",
  "nav.login":     "Giriş Yap",
  "nav.register":  "Üye Ol",
  "nav.logout":    "Çıkış Yap",
  "nav.account":   "Hesabım",

  /* ---------- Landing / Hero ---------- */
  "hero.kicker":      "Sınırsız eğlence",
  "hero.title":       "Sinemayı evinize getirin.",
  "hero.subtitle":    "En popüler canlı TV kanalları, yüzlerce film ve dizi seçeneği. 4K kalite. Tüm cihazlarınızda. Tek aboneliğe.",
  "hero.cta.primary": "Planları Gör",
  "hero.cta.ghost":   "Zaten üyeyim",
  "hero.trust":       "Kredi kartı ile 7/24 güvenli ödeme • Anında aktivasyon • İstediğin zaman iptal",

  "section.features.kicker":   "Neden biz",
  "section.features.title":    "Premium yayın deneyimi.",
  "feature.4k.title":          "4K UHD kalite",
  "feature.4k.desc":           "Desteklenen içeriklerde sinema kalitesinde görüntü.",
  "feature.library.title":     "Devasa kütüphane",
  "feature.library.desc":      "Filmler, diziler, belgeseller, canlı spor ve çok daha fazlası.",
  "feature.devices.title":     "Her cihaz",
  "feature.devices.desc":      "Android, iOS, Smart TV, Fire TV, Apple TV ve daha fazlası.",
  "feature.support.title":     "7/24 destek",
  "feature.support.desc":      "Gerçek insanlar — bot değil. Ortalama 5 dakika yanıt.",

  "section.plans.kicker":      "Planlar",
  "section.plans.title":       "Size uyan süreyi seçin.",
  "section.plans.subtitle":    "Uzun süreli planlarda daha avantajlı. İstediğin zaman iptal edebilirsin.",

  "section.cta.title":         "Bu gece sinema sende başlasın.",
  "section.cta.subtitle":      "Saniyeler içinde kayıt ol, anında yayına başla.",
  "section.cta.button":        "Hemen Başla",

  /* ---------- Plans page ---------- */
  "plans.page.title":          "Planlar",
  "plans.page.subtitle":       "3, 6 veya 12 ay. Sizin için en uygun olanı seçin.",
  "plans.months":              "{n} ay",
  "plans.per_month":           "/ay",
  "plans.billed_total":        "Toplam {amount} — tek seferde",
  "plans.select":              "Bu Planı Seç",
  "plans.current":             "Mevcut planınız",
  "plans.badge.popular":       "En popüler",
  "plans.badge.best_value":    "En avantajlı",

  /* Feature chips referenced from plans.js */
  "feature.channels_12k":      "Geniş canlı kanal listesi",
  "feature.vod_library":       "Tüm VOD kütüphanesi",
  "feature.fhd_1080p":         "Full HD 1080p",
  "feature.uhd_4k":            "4K UHD destekli içerik",
  "feature.two_devices":       "2 cihaza kadar",
  "feature.three_devices":     "3 cihaza kadar",
  "feature.five_devices":      "5 cihaza kadar",
  "feature.seven_day_epg":     "7 günlük EPG",
  "feature.fourteen_day_epg":  "14 günlük EPG",
  "feature.priority_support":  "Öncelikli destek",
  "feature.early_access":      "Yeni özelliklere erken erişim",

  /* ---------- Auth ---------- */
  "auth.login.title":          "Tekrar hoş geldin.",
  "auth.login.subtitle":       "Yayına devam etmek için giriş yap.",
  "auth.register.title":       "Hesabını oluştur.",
  "auth.register.subtitle":    "30 saniyede aboneliğe başla.",
  "auth.forgot.title":         "Şifreni mi unuttun?",
  "auth.forgot.subtitle":      "E-posta adresini gir, sıfırlama bağlantısı gönderelim.",
  "auth.field.email":          "E-posta",
  "auth.field.password":       "Şifre",
  "auth.field.name":           "Ad Soyad",
  "auth.field.confirm":        "Şifre (tekrar)",
  "auth.submit.login":         "Giriş yap",
  "auth.submit.register":      "Hesap oluştur",
  "auth.submit.forgot":        "Bağlantıyı gönder",
  "auth.forgot.link":          "Şifremi unuttum",
  "auth.no_account":           "Hesabın yok mu?",
  "auth.has_account":          "Zaten hesabın var mı?",
  "auth.back_to_login":        "Girişe dön",
  "auth.terms":                "Kaydolarak {terms} ve {privacy} koşullarını kabul etmiş olursun.",
  "auth.terms.terms":          "Kullanım Şartları",
  "auth.terms.privacy":        "Gizlilik Politikası",
  "auth.forgot.sent":          "Bağlantı gönderildi. Gelen kutunu kontrol et.",

  /* ---------- Dashboard ---------- */
  "dash.hello":                "Merhaba, {name}",
  "dash.welcome":              "Aboneliğini ve cihazlarını buradan yönetirsin.",
  "dash.subscription.title":   "Aboneliğin",
  "dash.subscription.plan":    "Plan",
  "dash.subscription.status":  "Durum",
  "dash.subscription.active":  "AKTİF",
  "dash.subscription.expires": "Bitiş tarihi",
  "dash.subscription.days":    "{n} gün kaldı",
  "dash.subscription.renew":   "Yenile",
  "dash.subscription.upgrade": "Yükselt",
  "dash.subscription.none":    "Aktif aboneliğin yok. İlk planını seç ve başla.",
  "dash.subscription.cta":     "Plan Seç",

  "dash.devices.title":        "Cihazlar",
  "dash.devices.count":        "{n} / {max} aktif",
  "dash.devices.manage":       "Yönet",

  "dash.account.title":        "Hesap",
  "dash.account.email":        "E-posta",
  "dash.account.member":       "Üyelik tarihi",

  "dash.quick.app":            "Uygulamayı indir",
  "dash.quick.plans":          "Planları incele",
  "dash.quick.support":        "Yardım al",

  /* ---------- Devices page ---------- */
  "devices.title":             "Cihaz Yönetimi",
  "devices.subtitle":          "Hesabında yayın yapabilen cihazların listesi.",
  "devices.add":               "Cihaz Ekle",
  "devices.name":              "Cihaz Adı",
  "devices.platform":          "Platform",
  "devices.last_seen":         "Son Görülme",
  "devices.added":             "Eklenme",
  "devices.revoke":            "Kaldır",
  "devices.empty.title":       "Henüz cihaz bağlı değil",
  "devices.empty.subtitle":    "Uygulamayı indir, ekrandaki eşleme kodunu buraya girerek cihazını bağla.",
  "devices.add.title":         "Yeni cihaz ekle",
  "devices.add.desc":          "Televizyonunda veya telefonunda uygulamayı aç, ekranda çıkan 6 haneli kodu gir.",
  "devices.add.code":          "Eşleme Kodu",
  "devices.add.submit":        "Bağla",
  "devices.add.hint":          "Kod 6 haneli ve yalnızca rakamlardan oluşur.",
  "devices.revoke.title":      "Cihazı kaldır",
  "devices.revoke.desc":       "{name} cihazı hesabından çıkarılacak. Yeniden bağlanabilmesi için kod girmesi gerekir.",
  "devices.revoke.confirm":    "Kaldır",
  "devices.revoke.cancel":     "Vazgeç",

  /* ---------- App downloads ---------- */
  "app.title":                 "Uygulamayı İndir",
  "app.subtitle":              "Tüm cihazlarında. Aynı hesap, aynı abonelik.",
  "app.detected":              "Cihazın algılandı:",
  "app.download":              "İndir",
  "app.qr.title":              "Telefonunla tara",
  "app.qr.desc":               "QR kodu tara, mobil uygulamayı mağazadan indir.",
  "app.platform.android":      "Android",
  "app.platform.ios":          "iOS",
  "app.platform.android_tv":   "Android TV",
  "app.platform.fire_tv":      "Fire TV",
  "app.platform.apple_tv":     "Apple TV",
  "app.platform.samsung_tv":   "Samsung Smart TV",
  "app.platform.lg_tv":        "LG webOS",
  "app.platform.windows":      "Windows",
  "app.platform.mac":          "macOS",
  "app.platform.web":          "Web",
  "app.platform.desktop":      "Masaüstü",

  /* ---------- Footer ---------- */
  "footer.copyright":          "© {year} {brand}. Tüm hakları saklıdır.",
  "footer.terms":              "Kullanım Şartları",
  "footer.privacy":            "Gizlilik",
  "footer.support":            "Destek",
  "footer.status":             "Sistem Durumu",

  /* ---------- Misc ---------- */
  "common.cancel":             "Vazgeç",
  "common.save":               "Kaydet",
  "common.loading":            "Yükleniyor…",
  "common.error":              "Bir şeyler ters gitti",
};

export default tr;
